import { render, staticRenderFns } from "./LuggageInfoBox.vue?vue&type=template&id=566322a8&"
import script from "./LuggageInfoBox.vue?vue&type=script&lang=js&"
export * from "./LuggageInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports